/* =====================================================================
   ERA — bruitages (17/10/2026), charges sur tout le site (layout/theme.liquid)
   Sons synthetises dans le navigateur (Web Audio) : aucun fichier a
   charger. Ils ne jouent qu'apres un geste de la cliente (toucher, clic).
   - add    : brume ajoutee au bundle (petite bulle + tinte)
   - remove : brume retiree (bulle descendante, tres discrete)
   - tier   : palier atteint (arpege de clochettes + scintillement)
   - cart   : ajout au panier (deux clochettes chaleureuses)
   ===================================================================== */
(() => {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;

  if (!AudioCtx) {
    window.eraSons = { play() {} };
    return;
  }

  let ctx = null;
  let bus = null;
  const lastPlayed = {};

  const setup = () => {
    if (ctx) {
      return;
    }

    ctx = new AudioCtx();

    const master = ctx.createGain();
    master.gain.value = 0.5;

    const compressor = ctx.createDynamicsCompressor();
    compressor.threshold.value = -20;
    compressor.ratio.value = 3;

    // un soupcon d'air : echo tres court, filtre, qui donne de la rondeur
    const delay = ctx.createDelay(0.5);
    delay.delayTime.value = 0.085;
    const feedback = ctx.createGain();
    feedback.gain.value = 0.22;
    const tone = ctx.createBiquadFilter();
    tone.type = 'lowpass';
    tone.frequency.value = 5200;
    const wet = ctx.createGain();
    wet.gain.value = 0.16;

    bus = ctx.createGain();
    bus.connect(master);
    bus.connect(delay);
    delay.connect(tone);
    tone.connect(feedback);
    feedback.connect(delay);
    tone.connect(wet);
    wet.connect(master);
    master.connect(compressor);
    compressor.connect(ctx.destination);
  };

  const envelope = (gainNode, t, peak, attack, release) => {
    gainNode.gain.setValueAtTime(0.0001, t);
    gainNode.gain.exponentialRampToValueAtTime(peak, t + attack);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, t + attack + release);
  };

  // clochette : fondamentale + partiels inharmoniques qui s'eteignent plus vite
  const bell = (t, freq, volume, length) => {
    [[1, 1], [2, 0.28], [2.76, 0.12], [5.4, 0.05]].forEach(([ratio, level]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = 'sine';
      osc.frequency.value = freq * ratio;
      envelope(gain, t, volume * level, 0.005, length / Math.sqrt(ratio));
      osc.connect(gain);
      gain.connect(bus);
      osc.start(t);
      osc.stop(t + length + 0.1);
    });
  };

  // bulle : sinus dont la hauteur glisse tres vite
  const bubble = (t, from, to, volume, length = 0.11) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = 'sine';
    osc.frequency.setValueAtTime(from, t);
    osc.frequency.exponentialRampToValueAtTime(to, t + 0.06);
    envelope(gain, t, volume, 0.004, length);
    osc.connect(gain);
    gain.connect(bus);
    osc.start(t);
    osc.stop(t + length + 0.05);
  };

  // scintillement : souffle aigu tres court
  const sparkle = (t, volume, length) => {
    const frames = Math.floor(ctx.sampleRate * length);
    const buffer = ctx.createBuffer(1, frames, ctx.sampleRate);
    const data = buffer.getChannelData(0);

    for (let i = 0; i < frames; i += 1) {
      data[i] = (Math.random() * 2 - 1) * (1 - i / frames);
    }

    const source = ctx.createBufferSource();
    const filter = ctx.createBiquadFilter();
    const gain = ctx.createGain();

    source.buffer = buffer;
    filter.type = 'highpass';
    filter.frequency.value = 7500;
    envelope(gain, t, volume, 0.01, length);
    source.connect(filter);
    filter.connect(gain);
    gain.connect(bus);
    source.start(t);
  };

  const SOUNDS = {
    add: (t) => {
      bubble(t, 480, 940, 0.3);
      bell(t + 0.025, 1567.98, 0.06, 0.35);
    },
    remove: (t) => {
      bubble(t, 620, 330, 0.14, 0.09);
    },
    tier: (t) => {
      bubble(t, 480, 940, 0.24);
      [1318.51, 1661.22, 1975.53, 2637.02].forEach((freq, i) => {
        bell(t + 0.05 + i * 0.075, freq, 0.1 - i * 0.012, 1);
      });
      sparkle(t + 0.08, 0.03, 0.5);
    },
    cart: (t) => {
      bubble(t, 330, 660, 0.28, 0.14);
      bell(t + 0.06, 1046.5, 0.12, 1.2);
      bell(t + 0.17, 1567.98, 0.11, 1.3);
      bell(t + 0.17, 2093, 0.035, 1);
      sparkle(t + 0.12, 0.025, 0.6);
    }
  };

  const play = (name) => {
    try {
      if (!SOUNDS[name]) {
        return;
      }

      const now = Date.now();

      if (lastPlayed[name] && now - lastPlayed[name] < 90) {
        return;
      }

      lastPlayed[name] = now;
      setup();

      if (ctx.state === 'suspended') {
        ctx.resume();
      }

      SOUNDS[name](ctx.currentTime + 0.01);
    } catch (error) {
      /* un son ne doit jamais bloquer l'achat */
    }
  };

  window.eraSons = { play };

  // Ajout au panier, partout sur le site :
  // 1. au clic sur un bouton d'ajout (son immediat, sans attendre le reseau) ;
  // 2. a defaut, quand un ajout reussit en arriere-plan (fetch vers /cart/add).
  let lastCart = 0;
  const playCart = () => {
    const now = Date.now();

    if (now - lastCart < 2500) {
      return;
    }

    lastCart = now;
    play('cart');
  };

  const ADD_BUTTONS = [
    'form[action*="/cart/add"] [type="submit"]',
    'form[action*="/cart/add"] button:not([type])',
    '[data-product-submit]',
    '.sd-product-hero__button',
    '.cart-drawer__upsell-button'
  ].join(',');

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(ADD_BUTTONS);

      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      // liste d'attente (« Etre prevenue ») : pas un ajout au panier
      if (button.matches('.era-wl-declencheur, [data-era-wl-trigger]') || button.getAttribute('data-era-page-preorder') === 'true') {
        return;
      }

      playCart();
    },
    true
  );

  if (window.fetch) {
    const nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      const request = nativeFetch.apply(this, arguments);

      if (method === 'POST' && /\/cart\/add/.test(url)) {
        request
          .then((response) => {
            if (response && response.ok) {
              playCart();
            }
          })
          .catch(() => {});
      }

      return request;
    };
  }
})();
